export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-queue/src/array.js
// module id = 394
// module chunks = 0